import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { AxiosRequestConfig } from 'axios';

import { getCSVInvoices } from 'api/billingService';

export const useGetCSVInvoicesListQuery = (config?: AxiosRequestConfig) => {
  const queryKey = ['csv-invoices', config ? JSON.stringify(config.params) : ''];
  return useQuery({
    queryKey,
    queryFn: () => {
      return getCSVInvoices(config);
    },
    placeholderData: keepPreviousData
  });
};
